import { Spinner } from "@/components/common/loading"
import { useRouter } from "@/components/context"
import c from "classnames"
import { USER_ESSENTIALS_FRAGMENT } from "@/fragments"
import gql from "graphql-tag"
import React from "react"
import { apolloClient } from "@/state/apollo-client"
import { landingPageUrl, switchingOrgsUrl, teamMetricsDefaultUrl } from "@/utils/url"
import { SpinnerButton } from "@/components/common/button"
import buttonStyle from "@sass/common/button.module.sass"

import { useMarkChatAsProcessedMutation } from "./__gen/process-button"

gql`
	mutation markChatAsProcessed($id: ID!, $processedAt: DateTime) {
		llmChatAdmin_Update(input: {id: $id, processedAt: $processedAt}) {
			object {
				id
				processedAt
			}
		}
	}
	${USER_ESSENTIALS_FRAGMENT}
`

type Props = {
	id: string
	processedAt: string | null
}

export const ProcessButton = ({ id, processedAt }: Props) => {
	const [mutate, { loading, error }] = useMarkChatAsProcessedMutation({
		variables: { id, processedAt: !processedAt ? new Date().toISOString() : null },
	})

	if (error) {
		return <p>Error: {error.message}</p>
	}

	return <SpinnerButton disabled={loading} loading={loading} onClick={() => mutate()}>{processedAt ? 'Unset' : 'Set'}</SpinnerButton>
}
